import { DefaultColumnKeys, IColumnType, IDataTableColumn } from '../../../../../../../../ui/gzDataTable/types';
import { translateFn } from '../../../../../../../../utils/translator.helper';
import { RequiredValidator } from '../../../../../../../../ui/gzForm/validators/required.validator';
import { HostnameValidator } from '../../../../../../../../ui/gzForm/validators/hostname.validator';
import { MinValidator } from '../../../../../../../../ui/gzForm/validators/min.validator';
import { MaxValidator } from '../../../../../../../../ui/gzForm/validators/max.validator';

const CONFIDENCE_LEVEL_MAX_PERCENT = 100;
const CONFIDENCE_LEVEL_MIN_PERCENT = 1;

export enum ColumnKeys {
  RBL_SERVER = 'server',
  CONFIDENCE_LEVEL = 'confidenceLevel',
}

export function getTableColumns(): IDataTableColumn[] {
  return [
    {
      key: ColumnKeys.RBL_SERVER,
      header: translateFn('RBL Server'),
      columnType: IColumnType.TEXT,
      validators: [
        RequiredValidator(translateFn('RBL server address is required.')),
        HostnameValidator(translateFn('Invalid RBL server address')),
      ],
    },
    {
      key: ColumnKeys.CONFIDENCE_LEVEL,
      header: translateFn('Confidence level ({percent})', { percent: '%' }),
      columnType: IColumnType.NUMBER,
      numberSuffix: '%',
      minValue: CONFIDENCE_LEVEL_MIN_PERCENT,
      maxValue: CONFIDENCE_LEVEL_MAX_PERCENT,
      validators: [RequiredValidator(translateFn('Confidence level is required.'))],
    },
    {
      key: DefaultColumnKeys.ACTIONS,
      header: translateFn('Actions'),
      columnType: IColumnType.DISPLAY,
    },
  ];
}
